import React, {useContext} from "react";
import Paper from "@material-ui/core/Paper";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Button from "@material-ui/core/Button";
import {MenuDesignerContext} from "../../../ContextComponents/MenuDesignerContext/MenuDesignerContext";

const useStyles = makeStyles(() => ({
    container: {
        marginTop: 3,
        height: 50,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
    },
    button: {
        marginRight: 5
    }
}));

const BottomMenu = () => {
    const {isUpdate, onSave, onOpenConfirmation, onCancel} = useContext(MenuDesignerContext);
    const classes = useStyles();
    return (
        <Paper className={classes.container} square>
            <Button
                variant={"contained"}
                color={"primary"}
                onClick={onSave}
                size={"small"}
                className={classes.button}
            >
                Save
            </Button>
            {isUpdate && (
                <Button
                    variant={"outlined"}
                    color={"secondary"}
                    onClick={onOpenConfirmation}
                    size={"small"}
                    className={classes.button}
                >
                    Delete
                </Button>
            )}
            <Button
                variant={"contained"}
                color={"default"}
                onClick={onCancel}
                size={"small"}
                className={classes.button}
            >
                Cancel
            </Button>
        </Paper>
    )
};
export default BottomMenu